
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-9083.99 3024.01 8.27 8.27"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_250_3","data-name":"Symbol 250 – 3","transform":"translate(-91 -97)","opacity":".87"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1819","d":"M0 6.29L6.29 0","data-name":"Line 1819","transform":"translate(-8992 3122)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1820","d":"M6.29 6.29L0 0","data-name":"Line 1820","transform":"translate(-8992 3122)"}})])])
          )
        }
      }
    